import { select, put, takeLatest, call } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../../common/common.types'
import { ClientDataConstants } from '../../../clientData/store/clientData.constants'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../user/selectors'
import { LabsService } from '../services/labs.service'
import { setAbgAccessOptions } from '../../../options/store/options.actions'

export function* getAbgAccessOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const labsService = new LabsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([labsService, labsService.getAbgAccessOptions])
    const { entity } = response
    yield put(setAbgAccessOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getAbgAccessOptions() error: ${e}`))
  }
}

export function* getAbgAccessOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAbgAccessOptions)
}
